import { connect } from "react-redux";

// TODO: Refactor TokenExpired when the SSO is refactored on the Magento backend
function TokenExpired(props) {
  // The following is commented out until M2-473 is fixed.
  // if (props.isAccessTokenExpired) {
  //   alert(
  //     'The Customer Access Token is expired. The page will be refreshed and you may need to login again.',
  //   )
  //   deleteToken()
  //   window.location.reload()
  // }

  const tokenExpireAtInMilliSeconds = props.expireAt * 1000;
  const tokenLifetime = tokenExpireAtInMilliSeconds - Date.now();

  if (tokenLifetime > 0) {
    console.log(
      `The Customer Access Token will be expired at ${new Date(
        tokenExpireAtInMilliSeconds
      )}`
    );

    console.log(
      `The remaining token lifetime is ${(tokenLifetime / 1000 / 3600).toFixed(
        2
      )} hours`
    );
  }

  // Alert 10 minutes before token expired
  const timeout = tokenLifetime - 1000 * 60 * 10;
  if (timeout > 0) {
    setTimeout(() => {
      alert(
        "Your session will expire in 10 minutes. Once your session expires, any unsaved changes to the quote will be lost. Save your quote now (from the Quote page) to avoid losing your changes."
      );
    }, timeout);
  }

  return null;
}

export default connect(({ authorization }) => ({
  isAccessTokenExpired: authorization.isAccessTokenExpired,
  expireAt: authorization.expireAt
}))(TokenExpired);
